import { Input, NumberInput } from "../../../../../../common/Input";

import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export function ObjectiveRow({
  objective,
  isEditing,
  editingObjective,
  errors,
  remainingPercentage,
  onStartEdit,
  onSaveEdit,
  onCancelEdit,
  onRemove,
  onEditFieldChange
}) {
  return (
    <tr className="group bg-white hover:bg-gray-50/50 border-t border-gray-100 transition-colors">
      {/* COLUMN 1: CODE */}
      <td className="px-4 py-2 w-32">
        <div className="flex items-center space-x-2">
          <div className="w-1.5 h-1.5 rounded-full bg-gray-300" />
          {isEditing ? (
            <Input
              type="text"
              value={editingObjective.code}
              onChange={(e) => onEditFieldChange("code", e.target.value)}
              className="!h-8 !text-sm" 
              error={errors.code}
            />
          ) : (
            /* Upgraded from 10px to xs (12px) for better legibility */
            <span className="text-xs font-mono text-gray-400 tracking-tight uppercase">
              {objective.code}
            </span>
          )}
        </div>
      </td>

      {/* COLUMN 2: DESCRIPTION */}
      <td className="px-4 py-2">
        {isEditing ? (
          <Input
            type="text"
            value={editingObjective.description}
            onChange={(e) => onEditFieldChange("description", e.target.value)}
            className="!h-8 !text-sm"
            error={errors.description}
          />
        ) : (
          /* Upgraded from text-xs to text-sm (14px) */
          <div className="text-sm font-normal text-gray-600 truncate max-w-md">
            {objective.description}
          </div>
        )}
      </td>

      {/* COLUMN 3: PERCENTAGE */}
      <td className="px-4 py-2 w-24">
        {isEditing ? (
          <NumberInput
            value={editingObjective.percentage}
            onChange={(e) => onEditFieldChange("percentage", e.target.value)}
            className="!h-8 !text-sm"
            error={errors.percentage}
          />
        ) : (
          /* Changed to text-sm */
          <span className="text-sm font-medium text-gray-500">
            {objective.percentage}%
          </span>
        )}
      </td>

      {/* COLUMN 4: ACTIONS */}
      <td className="px-4 py-2 text-center w-28">
        <div className="flex justify-center space-x-1">
          {isEditing ? (
            <>
              <button
                onClick={onSaveEdit}
                className="p-1.5 bg-transparent border-none text-green-500 hover:text-green-600 rounded transition-colors"
                title="Save"
              >
                <CheckIcon className="!w-5 !h-5" />
              </button>
              <button
                onClick={onCancelEdit}
                className="p-1.5 bg-transparent border-none text-gray-400 hover:text-gray-600 rounded transition-colors"
                title="Cancel"
              >
                <CloseIcon className="!w-5 !h-5" />
              </button>
            </>
          ) : (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onStartEdit(objective);
                }}
                className="p-1.5 bg-transparent border-none text-gray-400 hover:text-blue-500 rounded transition-colors"
                title="Edit"
              >
                <EditIcon className="!w-5 !h-5" />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(objective.id);
                }}
                className="p-1.5 bg-transparent border-none text-red-500 hover:text-red-600 rounded transition-colors"
                title="Delete"
              >
                <DeleteIcon className="!w-5 !h-5" />
              </button>
            </>
          )}
        </div>
      </td>
    </tr>
  );
}